// The single "choose a workflow" action, shared by the sidebar pill and the landing-page cards.
// Both must persist the choice AND navigate — duplicating that would give a landing-page CTA that
// navigates without setting the rail.
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  type ScoutVertical,
  VERTICAL_STORAGE_KEY,
  WORKFLOW_META,
} from '@/components/layout/Sidebar/sidebarNav';

export function useWorkflowSwitch(): (workflow: ScoutVertical) => void {
  const navigate = useNavigate();
  return useCallback(
    (workflow: ScoutVertical) => {
      try {
        localStorage.setItem(VERTICAL_STORAGE_KEY, workflow);
      } catch {
        /* ignore — private mode / disabled storage still navigates */
      }
      navigate(WORKFLOW_META[workflow].firstPath, { viewTransition: true });
    },
    [navigate],
  );
}
